'use strict';

/**
 * This uses localytics for analytics engine.
 * 
 * The following needs to be in your head.
 * If using nwjs, substitute the parameter 'window' with 'global'
 <script>
 function(l, y, t, i, c, s) {
        l['LocalyticsGlobal'] = i;
        l[i] = function() {
            (l[i].q = l[i].q || []).push(arguments)
        };
        l[i].q = []; //avoids timing bug...
        l[i].t = +new Date;
        (s = y.createElement(t)).type = 'text/javascript';
        s.src = '//web.localytics.com/v3/localytics.min.js';
        (c = y.getElementsByTagName(t)[0]).parentNode.insertBefore(s, c);
    }(window, document, 'script', 'll');
 </script>
 * 
 * @param {Object} options
 * @param {string} options.key - The localytics key to pass to init
 * @param {Object} options.options - Bag of properties you can pass to the init call
 * @param {Object} options.ll - global.ll object, required only for nwjs
 */
module.exports = function (options) {

    if (options && options.ll !== undefined) ll = options.ll;

    var llDefined = typeof ll === 'function';

    if (!llDefined) {
        console.warn('window.ll (global.ll if nwjs) is required to be defined for this to work.  No errors or analytics will be pushed!');
    } else {
        ll('init', options.key, options.options);
    }

    /**
     * push a 'tagEvent' up to localyitcs
     * @param {string} eventType
     * @param {Object} payload
     */
    this.pushEvent = function (eventType, payload, ltv) {
        if (llDefined) {
            ll('tagEvent', eventType, payload, ltv);
        }
    };

    this.createNewSession = function () {
        if (llDefined) {
            ll('close');
        }
    };

    this.setUserId = function (userId) {
        if (llDefined) {
            ll('setCustomerId', userId);
        }
    };

    this.setCustomerId = function (userId) {
        if (llDefined) {
            console.warn('For Localytics, prefer AnalyticsInstance.setUserId to AnalyticsInstance.setCustomerId');
            this.setUserId(userId);
        }
    };

    this.setUserIdentity = function (identity) {
        if (llDefined) {
            if (identity.firstName) ll('setCustomerFirstName', identity.firstName);
            if (identity.lastName) ll('setCustomerLastName', identity.lastName);
            if (identity.fullName) ll('setCustomerFullName', identity.fullName);
            if (identity.email) ll('setCustomerEmail', identity.email);
        }
    };

    this.setProfileAttribute = function (attribute, value, scope) {
        if (llDefined) {
            ll('setProfileAttribute', attribute, value, scope);
        }
    };

    this.deleteProfileAttribute = function (attribute, scope) {
        if (llDefined) {
            ll('deleteProfileAttribute', attribute, scope);
        }
    };

    this.incrementProfileAttribute = function (attribute, value, scope) {
        if (llDefined) {
            ll('incrementProfileAttribute', attribute, value, scope);
        }
    };

    this.decrementProfileAttribute = function (attribute, value, scope) {
        if (llDefined) {
            ll('decrementProfileAttribute', attribute, value, scope);
        }
    };

    this.addProfileAttributesToSet = function (attribute, value, scope) {
        if (llDefined) {
            ll('addProfileAttributesToSet', attribute, value, scope);
        }
    };

    this.removeProfileAttributesFromSet = function (attribute, value, scope) {
        if (llDefined) {
            ll('removeProfileAttributesFromSet', attribute, value, scope);
        }
    };

    this.setCustomDimension = function (dimensionNumber, value) {
        if (llDefined) {
            ll('setCustomDimension', dimensionNumber, value);
        }
    };

    this.clearCustomDimension = function (dimensionNumber) {
        if (llDefined) {
            ll('setCustomDimension', dimensionNumber, null);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/LocalyticsProvider.js
// module id = 858
// module chunks = 0